/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function InheritedAccountTagFromJSON(json) {
    return InheritedAccountTagFromJSONTyped(json, false);
}
export function InheritedAccountTagFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        accountTagId: json['accountTagId'],
        ancestorName: json['ancestorName'],
        ancestorId: json['ancestorId'],
        depth: json['depth'],
    };
}
export function InheritedAccountTagToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        accountTagId: value.accountTagId,
        ancestorName: value.ancestorName,
        ancestorId: value.ancestorId,
        depth: value.depth,
    };
}
